import React from 'react';
import DoctorAvatar from '../../pages/landing/DoctorAvatar';

/** Compact doctor summary for the public booking doctor step. */
export default function BookingDoctorCard({ doctor, active, primary }) {
  const specialty = doctor.specialization || doctor.spec || 'General consultation';
  return (
    <div className="flex items-start gap-3">
      <DoctorAvatar doctor={doctor} primary={primary} size="sm" />
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-zinc-100 text-sm leading-snug">{doctor.name}</p>
        {doctor.title ? (
          <p className="text-[11px] text-zinc-500 mt-0.5">{doctor.title}</p>
        ) : null}
        <p
          className="text-[12px] font-medium mt-1"
          style={{ color: active ? primary : '#a1a1aa' }}
        >
          {specialty}
        </p>
        {doctor.qualifications ? (
          <p className="text-[11px] text-zinc-500 mt-1 line-clamp-2">{doctor.qualifications}</p>
        ) : null}
        {doctor.bio ? (
          <p className="text-[11px] text-zinc-500 mt-1 line-clamp-2 leading-relaxed">{doctor.bio}</p>
        ) : null}
      </div>
    </div>
  );
}
